// components/LoginForm.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { CREDENTIALS } from '../App';

const LoginForm = ({ onLogin }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  // Verificar si ya hay una sesión guardada al cargar el componente
  useEffect(() => {
    const savedSession = localStorage.getItem('sistemaAumentosSession');
    if (savedSession) {
      try {
        const sessionData = JSON.parse(savedSession);
        const currentTime = new Date().getTime();
        
        // Verificar si la sesión no ha expirado (24 horas por defecto)
        if (sessionData.expiry && currentTime < sessionData.expiry) {
          onLogin();
        } else {
          // Si la sesión expiró, limpiar localStorage
          localStorage.removeItem('sistemaAumentosSession');
        }
      } catch (error) {
        console.error('Error al recuperar la sesión:', error);
        localStorage.removeItem('sistemaAumentosSession');
      }
    }
  }, [onLogin]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (loginData.username === CREDENTIALS.username && loginData.password === CREDENTIALS.password) {
      setLoginError('');
      
      // Si el usuario marcó "Recordarme", guardar en localStorage
      if (rememberMe) {
        const sessionData = {
          username: loginData.username,
          loginTime: new Date().getTime(),
          expiry: new Date().getTime() + (24 * 60 * 60 * 1000) // 24 horas
        };
        localStorage.setItem('sistemaAumentosSession', JSON.stringify(sessionData));
      }
      
      onLogin();
    } else {
      setLoginError('Usuario o contraseña incorrectos');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            💰 Sistema de Aumentos
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
            Ingrese sus credenciales para acceder
          </Typography>
          
          {loginError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {loginError}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Usuario"
              value={loginData.username}
              onChange={(e) => setLoginData(prev => ({ ...prev, username: e.target.value }))}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Contraseña"
              type={showPassword ? 'text' : 'password'}
              value={loginData.password}
              onChange={(e) => setLoginData(prev => ({ ...prev, password: e.target.value }))}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  color="primary"
                />
              }
              label="Recordar sesión"
              sx={{ mt: 1, mb: 1 }}
            />
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
            >
              Iniciar Sesión
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginForm;